import { render, staticRenderFns } from "./ContextPopupView.vue?vue&type=template&id=895c092c&scoped=true&"
import script from "./ContextPopupView.vue?vue&type=script&lang=js&"
export * from "./ContextPopupView.vue?vue&type=script&lang=js&"
import style0 from "./ContextPopupView.vue?vue&type=style&index=0&id=895c092c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895c092c",
  null
  
)

export default component.exports